import { Button, message, Modal } from 'antd'
import { useState } from 'react'
import { AlertErrorCompact } from '../../error-compact'
import { useFormatMessage } from '../../../helpers/intl'
import { SwtchError } from '../../../models/error'
import { Subscription } from '../../../models/subscription'
import { CancelSubscription } from '../../../services/data-provider/subscriptions'
import { FooterLayout } from '../../../atom/user-edit'
import { HeadingWrapper, TextBodyWrapper } from '../../../atom/plans'

interface props {
  subscription: Subscription
  onCancel: () => void
  onCancelSubscription: () => void
}

export const CancelSubscriptionRedesignModal: React.FC<props> = ({ subscription, onCancel, onCancelSubscription }) => {
  const [error, setError] = useState<SwtchError>()
  const [loading, setLoading] = useState(false)

  const okText = useFormatMessage('dashboard.text.cancelSubscription', 'Cancel Subscription')
  const closeText = useFormatMessage('dashboard.text.close', 'Close')
  const deleteMessage = useFormatMessage(
    'dashboard.subscriptionsPage.modal.cancel',
    'Are you sure you want to cancel the subscription for',
  )

  const onOk = () => {
    setError(undefined)
    setLoading(true)
    CancelSubscription(subscription)
      .then((msg) => {
        message.success(msg)
        onCancelSubscription()
      })
      .catch((error: SwtchError) => setError(error))
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      title={<HeadingWrapper>{useFormatMessage('dashboard.text.cancelSubscription', 'Cancel Subscription')}</HeadingWrapper>}
      okText={okText}
      cancelText={closeText}
      visible={true}
      onCancel={onCancel}
      onOk={onOk}
      width={568}
      afterClose={onCancel}
      footer={<FooterLayout>
        <Button key="back" loading={loading} onClick={onCancel}>
          {closeText}
        </Button>
        <Button className="red" key="submit" type="primary" danger loading={loading} onClick={onOk}>
          {okText}
        </Button>
        </FooterLayout>}
    >
      <AlertErrorCompact error={error} />
      <TextBodyWrapper>{deleteMessage} <strong>"{subscription.subscriber.email}"</strong>?</TextBodyWrapper>
    </Modal>
  )
}
